'use client';
import { Box, Fade, Grow, IconButton, Typography } from '@mui/material';
import React, { useState } from 'react';
import ExpandLessOutlinedIcon from '@mui/icons-material/ExpandLessOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';

import ExpandMoreOutlinedIcon from '@mui/icons-material/ExpandMoreOutlined';

import { useTranslation } from 'react-i18next';
import { useShoppingCart } from '@/context/ShoppingCartContext';

function AssuredTaskingLegend() {
  const [minimize, setMinimize] = useState(false);
  const { t } = useTranslation('orderImagery');
  const { setTaskingMapLegends } = useShoppingCart();

  interface taskingMapLegendsInterface {
    assuredTasking: boolean;
    droneTasking: boolean;
  }
  return minimize ? (
    <Fade in={true} mountOnEnter unmountOnExit>
      <Box className="at-info-icon-bar-wrap">
        <IconButton
          className="at-info-icon-bar-content"
          onClick={() => {
            setMinimize(false);
          }}
        >
          <Typography variant="body2">
            {t('airbusGuaranteedTasking', 'Airbus Guaranteed Tasking')}
          </Typography>
          <ExpandLessOutlinedIcon className="at-info-icon-bar-content" />
        </IconButton>
      </Box>
    </Fade>
  ) : (
    <Grow unmountOnExit in={true} style={{ transformOrigin: '0 0 0' }} timeout={500}>
      <Box className="at-info-dialog-wrap">
        <Box className="action-btns">
          <IconButton
            onClick={() => {
              setMinimize(true);
            }}
          >
            <ExpandMoreOutlinedIcon sx={{ fontSize: '1rem' }} />
          </IconButton>
          <IconButton
            onClick={() => {
              setTaskingMapLegends({ assuredTasking: false, droneTasking: false });
            }}
          >
            <CloseOutlinedIcon sx={{ fontSize: '1rem' }} />
          </IconButton>
        </Box>

        <Typography className="at-info-title" variant="body1">
          {t('assuredTaskingAOIRequire', 'Airbus Guaranteed Tasking AOI Requirements')}
        </Typography>
        <ul className="at-info-list">
          <li className="at-info-list-item">{`${t('minAOI', 'Min AOI')}: 25km²`}</li>
          <li className="at-info-list-item">{`${t('minOrderArea', 'Min Order Area')}: 100km²`}</li>
          <li className="at-info-list-item">{`${t('maxOrderArea', 'Max Order Area')}: 400km²`}</li>
          <li className="at-info-list-item">{`${t('maxHeight', 'Max Height')}: 30km`}</li>
          <li className="at-info-list-item">{`${t('maxWidth', 'Max Width')}: 13km`}</li>
        </ul>
      </Box>
    </Grow>
  );
}

export default AssuredTaskingLegend;
